import { useEffect, useState } from "react";

export default function useHeatpumpSgReadySoc(
  heatpump,
  setSgReadySoc,
  showMsg = null,
  isFocused = true,
) {
  const [selectedSoc, setSelectedSoc] = useState(null);

  const loadData = () => {
    setSelectedSoc(heatpump.sg_ready_soc_threshold);
  };

  const clearData = () => setSelectedSoc(null);

  const initData = loadData;

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  const validateSoc = (soc) => {
    return typeof soc === "number" && soc >= 0 && soc <= 100;
  };

  const onSubmit = async (onSuccess) => {
    if (!validateSoc(selectedSoc)) {
      showMsg?.(
        "Batterieladezustand muss ein Wert zwischen 0 und 100 sein.",
        "error",
      );
      return;
    }
    try {
      await submit(selectedSoc);
      onSuccess?.();
      showMsg?.("Batterieladezustand geändert.");
    } catch (error) {
      console.warn('Error in "ModifySocModal:onSubmit"', error, error.stack);
      showMsg?.("Batterieladezustand konnte nicht geändert werden.");
    }
  };

  const submit = async (selectedSoc) => {
    return setSgReadySoc(selectedSoc);
  };

  return {
    onSubmit,
    soc: {
      value: selectedSoc,
      setValue: setSelectedSoc,
      validate: validateSoc,
    },
    data: { update: loadData, init: initData, clear: clearData },
  };
}
